/**
 * Issue #1798: where the dashboard sends a visitor who wants the free full
 * audit. Sign-up grants no audit since the #1782 cutover (the signup audit was
 * removed in #1784); the free full audit is the anonymous one on the marketing
 * homepage (POST /api/anonymous-audit, the `#audit` form).
 *
 * The marketing homepage's audit form. No domain prefill: the homepage form
 * reads no query parameter today, so passing one would promise a prefill the
 * page does not do.
 */
export function freeAuditUrl(): string {
  return `${marketingOrigin()}/#audit`;
}

/** The marketing site's sample of an unlocked report, for a visitor deciding whether to pay. */
export function sampleReportUrl(): string {
  return `${marketingOrigin()}/sample-report`;
}

function marketingOrigin(): string {
  const marketingUrl = process.env.REACT_APP_MARKETING_URL || 'https://getprivisy.com';
  return marketingUrl.replace(/\/$/, '');
}
